var _path, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterBgL(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 472 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M471.51 364.806H234C234 364.806 260.159 335.449 349.655 336.7C457.054 337.946 471.51 364.806 471.51 364.806Z",
    fill: "#D1D048"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2451_5859",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 268,
    height: 241
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.740234,
    width: 268,
    height: 240,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2451_5859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.148 217.74C181.389 208.991 180.577 189.759 159.405 182.819C146.894 178.718 139.194 180.888 134.771 184.666C141.381 171.32 145.728 152.841 129.79 146.118C125.659 143.449 112.945 139.312 95.1344 144.116C102.136 128.991 109.207 95.9384 81.4821 84.728C53.7574 73.5176 31.9838 86.4332 24.5625 94.2924C23.4423 83.3934 14.6488 63.9087 -11.5635 73.1617C-34.4574 78.9448 -49.5799 89.399 -50 101.633V217.661L179.148 217.74Z",
    fill: "#D1D048"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBgL);
export default __webpack_public_path__ + "static/media/footer-bg-l.c979702fae7db5f0d8a0a443d9307cf1.svg";
export { ForwardRef as ReactComponent };